import request from "@/utils/request";
import { decryptUserInfo } from "@/utils/sm2";

export function login(data) {
  return request({
    url: '/token/loginUser',
    method: 'post',
    data: data,
  })
}

//首页 获取当前登录用户
export function getCurrentUser() {
  return request({
    url: '/token/i',
    method: 'get',
  }).then(data => {
    return decryptUserInfo(data);
  });
}
